import { render, staticRenderFns } from "./detailOrder.vue?vue&type=template&id=6a09d533&"
import script from "./detailOrder.vue?vue&type=script&lang=js&"
export * from "./detailOrder.vue?vue&type=script&lang=js&"
import style0 from "./detailOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports